




























































import Vue from 'vue';
import store, { AttributeDef } from '../store';
import { Route } from 'vue-router';
import $ from 'jquery';

function routeHelper(to: Route, from: Route, next: ((to?: false | string | void | any) => void)): void {
    const n = Number(to.params.n) || 1;

    store.dispatch('activatePage', { n }).then(() => {
        next();
    }, () => {
        next(from.name ? false : { name: 'page', params: { n: 1} } );
    });
}


const Page = Vue.extend({
    data() {
        return {
            wasValidated: false,
            lastN: -1,
        };
    },
    computed: {
        page() {
            return store.state.page;
        },
        pages() {
            return store.state.pages;
        },
        isIframe() {
            return store.getters.isIframe;
        },
        productsCount() {
            return store.state.productsCount;
        },
        productId() {
            return (store.state.product && store.state.product.id) || null;
        },
    },
    watch: {
        page(newVal, oldVal) {
            // FIXME find better solution
            newVal = (newVal && newVal.n) || -1;
            if (newVal !== this.lastN) {
                this.wasValidated = false;
                this.lastN = newVal;
            }
        },
        productId(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                const router = this.$router;
                Vue.nextTick(() => {
                    router.push({ name: 'product'});
                });
            }
        },
    },
    methods: {
        next(event: Event) {
            const form = event.target as HTMLFormElement;

            if (form.checkValidity() === true) {
                let nextN = -1;
                if (this.page && (this.page.n !== this.pages.length)) {
                    nextN = this.page.n + 1;
                }
                while (nextN >= 0) {
                    const page = this.pages.find((p) => p.n === nextN);
                    if (page && page.isAutoComplete) {
                        nextN = (page.n !== this.pages.length ? page.n + 1 : -1);
                    } else {
                        break;
                    }
                }
                if (nextN >= 0)  {
                    this.$router.push({ name: 'page', params: {n: String(nextN)}});
                } else {
                    this.$router.push({ name: 'product'});
                }
            }
            this.wasValidated = true;
        },
        attributeChange(event: Event, attribute: AttributeDef) {
            const select = event.target as HTMLSelectElement;
            const value = select.value;
            store.dispatch('setAttribute', { attribute, value, isValueByUser: true });
        },
        reset() {
            store.dispatch('resetAll');
        },
    },
    beforeRouteEnter(to, from, next) {
        routeHelper(to, from, next);
    },
    beforeRouteUpdate(to, from, next) {
        routeHelper(to, from, next);
    },
});

export default Page;
